import { render, staticRenderFns } from "./printer-test.vue?vue&type=template&id=88118318&scoped=true&"
import script from "./printer-test.vue?vue&type=script&lang=js&"
export * from "./printer-test.vue?vue&type=script&lang=js&"
import style0 from "./printer-test.vue?vue&type=style&index=0&id=88118318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88118318",
  null
  
)

export default component.exports